<template>
 <div style="flex:1 0 auto;position:relative;" v-if="canRender">
    <v-card class="ma-2 maincontent" >      
      <v-card-title style="flex-direction:column;align-items:stretch;height:100%;">        
         <v-layout row wrap style="flex:1 0;overflow:auto;align-items:flex-start;" >
          <v-flex class="inline-block px-4">
              <h2 class="ml-0" style="flex:0 0 auto;">{{$t('Admin.PwdPolicy.FullTitle')}}</h2>              
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.minLength" :label="$t('Admin.PwdPolicy.MinLength')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.nbMinNumberChar" :label="$t('Admin.PwdPolicy.MinNumber')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.nbMinSpecialChar" :label="$t('Admin.PwdPolicy.MinSpecial')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.nbMinUpperChar" :label="$t('Admin.PwdPolicy.MinUpperCase')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.nbMinLowerChar" :label="$t('Admin.PwdPolicy.MinLowerCase')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.nbHistoryRetention" :label="$t('Admin.PwdPolicy.HistoryRetention')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.validityPeriod" :label="$t('Admin.PwdPolicy.ValidityPeriod')" />
              <number-field-factor hide-details dense v-model.number="configPwdPolicy.expireMessagePeriod" :label="$t('Admin.PwdPolicy.ExpirePeriod')" />
              <v-switch hide-details dense v-model="configPwdPolicy.denyAccessIfPassHasExpired" :label="$t('Admin.PwdPolicy.DenyAccessIfPassHasExpired')"></v-switch>
              <v-switch hide-details dense v-model="configPwdPolicy.denyAccessIfPassHasNoDate" :label="$t('Admin.PwdPolicy.DenyAccessIfPassHasNoDate')"></v-switch>
              <v-switch hide-details dense v-model="configPwdPolicy.disablePasswordPolicy" :label="$t('Admin.PwdPolicy.DisablePasswordPolicy')"></v-switch>
          </v-flex>                                   
        </v-layout>          
        <v-layout class="pt-2 adm-button" row wrap >          
          <v-btn :disabled="loading || !modified" @click.prevent="annuler">{{$t('Admin.Cancel')}}<v-icon right>mdi-restore</v-icon></v-btn>
          <v-btn :disabled="loading || !modified" @click.prevent="sauvegarde">{{$t('Admin.Save')}}<v-icon right>mdi-content-save</v-icon></v-btn>
        </v-layout>          
      </v-card-title>          
    </v-card> 
    <!-- Dialog de chargement... -->   
    <v-dialog
      v-model="loading"
      hide-overlay
      persistent
      width="300">
      <v-card color="primary" dark >
        <v-card-text>
          {{status}}
          <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script lang="ts">
import Vue from 'vue'
import Component from 'vue-class-component'
import { Watch} from 'vue-property-decorator'
import { AloDbBase } from '@/models/alodb/AloDbBase'
import camelCase from 'lodash.camelcase'
import { VuetifyConfirmObject } from 'vuetify-confirm'
import { DataPoolGlobalKeys } from '@/enum/DataPool'
import {MsgAccueil} from '@/models/datapool/MsgAccueil'
import { AloDataPoolItem } from '@/models/alo/AloDataPoolItem'
import deepEqual from 'deep-equal'
import { SecurityItemsKeys } from '@/enum/SecurityItems'
import { PasswordPolicy } from '@/models/datapool/PasswordPolicy'



@Component({
  name: 'AdminMsgAccueil'  
})
export default class AdminMsgAccueil extends Vue {      
    
  loading = false
  canRender = true
  status = ""
  configPwdPolicy = new PasswordPolicy()

  created() {                            
    if(!this.$store.myGetters.userSecurity[SecurityItemsKeys.ADMIN_PWD_POLICY].enable) {
      this.canRender = false       
      this.$router.push('/')
    }     
  }
  
  get modified() {
    return !deepEqual(this.originalPasswordPolicy,this.configPwdPolicy)
  }

  

  get originalPasswordPolicy(){
    return PasswordPolicy.createPasswordPolicy(this.$store.myGetters.dataPoolItemsValueByKey(DataPoolGlobalKeys['global.config.passwordPolicy']))
  }

  mounted(){
    this.loading = true
    this.status = this.$t('Admin.PwdPolicy.Loading').toString()
    this.$store.myActions.DATAPOOL_ENSURE({fullKey:DataPoolGlobalKeys['global.config.passwordPolicy']}).then(()=> {
      this.annuler()
      this.status = this.$t('Admin.PwdPolicy.Loaded').toString()
    }).finally(()=>{
      this.loading = false;
    });    
  }
  
  /*Fonctions*/  
  sauvegarde() {
    //@ts-ignore
    this.status = this.$t('Admin.PwdPolicy.Loading').toString()
    this.loading = true
    this.$store.myActions.DATAPOOL_UPDATE_REQUEST(
        new AloDataPoolItem({
        dtaValue:JSON.stringify(this.configPwdPolicy),
        dtaKey:DataPoolGlobalKeys['global.config.passwordPolicy']
      })).then((data)=>{
        this.status = this.$t('Admin.PwdPolicy.Loaded').toString()
        this.annuler()
      }).finally(()=>{
        this.loading = false
      })      
  }
  
  annuler() {
    //@ts-ignore
    this.configPwdPolicy = new PasswordPolicy(this.originalPasswordPolicy)
  }

}
</script>